import {makeAutoObservable} from "mobx";
import {ValidatedValue} from "../../helpers/validatedValue";
import Validator from "../../helpers/validator";
import i18n from "../../i18n/i18n";
import { errorMessages } from "../../helpers/errorMessage";

export interface IParkingRateInStore {
    parkingTime: ValidatedValue<string>;
    setParkingTime: (parkingTime: string) => void;
    parkingFee: ValidatedValue<string | number | null>;
    setParkingFee: (parkingFee: string | number | null) => void;
}

export class ParkingRateInStore implements IParkingRateInStore {
    _parkingTime: ValidatedValue<string>;
    _parkingFee: ValidatedValue<string | number | null>;

    constructor() {
        makeAutoObservable(this);

        const notEmptyValidator = {
            name: "valueIsNotEmpty",
            fn: Validator.isNotEmpty,
            errorMessage: errorMessages.required
        };

        const valueHasNoMoreThanTwoDecimalPlacesOrEmptyAndPositiveNumber = {
            name: "valueHasNoMoreThanTwoDecimalPlacesOrEmptyAndPositiveNumber",
            fn: (value: number) => {
                return Validator.isOnlyPositiveNumberWithCommaOrEmpty(value.toString()) && Validator.hasNoMoreThanTwoDecimalPlacesOrEmpty(value.toString());
            },
            errorMessage: () => i18n.t("priceList.errors.hasNoMoreThanTwoDecimalPlacesOrEmptyAndPositiveNumber")
        };

        const isOnlyPositiveNumberOrEmpty = {
            name: "isOnlyPositiveNumberOrEmpty",
            fn: (value: string) => {
                return Validator.isOnlyPositiveNumberOrEmpty(value);
            },
            errorMessage: () => i18n.t("errorMessages.onlyNumber")
        };

        const numberGreaterThanZeroOrEmpty = {
            name: "numberGreaterThanZero",
            fn: (value: string) => {
                if (!value) {
                    return true;
                }

                return Validator.numberGreaterThanZero(Number.parseInt(value));
            },
            errorMessage: () => i18n.t("priceList.errors.numberGreaterThanZero")
        };

        this._parkingTime = new ValidatedValue("", [isOnlyPositiveNumberOrEmpty, numberGreaterThanZeroOrEmpty, notEmptyValidator]);
        this._parkingFee = new ValidatedValue("", [valueHasNoMoreThanTwoDecimalPlacesOrEmptyAndPositiveNumber, notEmptyValidator]);
    }

    get parkingTime() {
        return this._parkingTime;
    }

    setParkingTime(parkingTime: string) {
        this._parkingTime.setValue(parkingTime);
    }

    get parkingFee() {
        return this._parkingFee;
    }

    setParkingFee(parkingFee: string | number | null) {
        this._parkingFee.setValue(parkingFee);
    }
}